import { createContext, type Context } from 'react';
import type { ViewMode } from '@jira/issue__issue-preview-view-mode-storage/src/getViewModeFromLocalStorage.tsx';

// Package-internal context for the current preview-mode value. External consumers must subscribe
// through useViewMode(); this context is not part of the public API.
export const viewModeStateContext: Context<ViewMode> = createContext<ViewMode>('DEFAULT');
